import { Icon } from "./Icon.jsx";
import { translate } from "../locales/index.js";

export function ThemeButton({ discussit, disabled, onOpen }) {
  return (
    <button
      type="button"
      className="theme-button button button--outline"
      data-theme={discussit.key}
      disabled={disabled}
      onClick={() => onOpen(discussit)}
    >
      <Icon name={discussit.key} className="theme-button__icon" />
      <span className="theme-button__title">
        {translate(`themes.${discussit.key}`)}
      </span>
    </button>
  );
}
